<template>
  <div v-if="errors.length > 0" class="errors">
    <div v-for="(error, key) in errors" :key="key" class="error">
      {{ error }}
    </div>
  </div>
  <div v-if="visible" class="services__wrapper">
    <div class="service__title">Подать заявление о Расторжении договора</div>
    <div class="service__content">
      <div class="contract-selector">
        <div class="dropdown">
          <input v-model="chosenElement" type="text" id="contract-select" placeholder="Выберите договор"
                 @click="toggleDropdown()">
          <img v-if="!dropdownIsOpened" src="@/profile/assets/icons/arrow-bottom.svg" alt="arrow-bottom"
               class="dropdown__arrow" @click="toggleDropdown()">
          <img v-else-if="dropdownIsOpened" src="@/profile/assets/icons/arrow-top.svg" alt="arrow-top"
               class="dropdown__arrow" @click="toggleDropdown()">
          <div v-if="dropdownIsOpened" class="dropdown-content">
            <div v-for="contract in contracts" :key="contract.id" class="dropdown-item"
                 @mousedown="contractClickHandle(contract)">
              Договор {{ contract.name }} от {{ contract.date }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <MakcDialogComponent2
    :title="'Подтвердите свои действия'"
    :text="'Пожалуйста, подтвердите расторжение договора'"
    :buttons="[{text: 'Расторгнуть', action: 'terminate'}, {text: 'Сохранить договор', action: 'hideDialog'}]"
    :icon="'warning'"
    :width="'615px'"
    v-model:show="modal_show"
    @cancel="modal_show = false; canceled = true"
    @terminate="terminate"
  />
  <MakcDialogComponent
    :title="'Мы рады продолжить сотрудничество!'"
    :text="formattedText"
    :icon="'success'"
    :width="'815px'"
    btn_text="OK"
    v-model:show="canceled"
  />
  <div v-if="video" class="popupWrapper">
    <div class="videoPopup">
      <img @click="video = false" src="@/profile/assets/icons/close_btn.svg" alt="close"
           class="videoPopup__close-btn">
      <p class="videoPopup__question">
        Отказ от страхования? Ответы на вопросы в видеоролике
      </p>
      <iframe
        class="videoPopup__iframe" width="789" height="437"
        src="https://kinescope.io/embed/wYXrzsYUZuRG1nDjF9GSXE"
      ></iframe>
      <!--      <p class="videoPopup__info">-->
      <!--        Возможность подтвердить желание расторгнуть договор активируется после просмотра видео-->
      <!--      </p>-->
      <div class="videoPopup__btn-container">
        <span class="videoPopup__btn-terminate" @click="terminate">
          Расторгнуть
        </span>
        <span class="videoPopup__btn-save" @click="canceled = true; video = false">
          Сохранить договор
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { url } from "@/profile/composables/url";
import MakcDialogComponent from "@/profile/components/UI/MakcDialogComponent";
import MakcDialogComponent2 from "@/profile/components/UI/MakcDialogComponent2";

export default {
  name: "TerminationStatementListComponent",
  components: { MakcDialogComponent, MakcDialogComponent2 },
  data: () => {
    return {
      contracts: [],
      modal_show: false,
      ra_show: false,
      visible: false,
      errors: [],
      saved: false,
      canceled: false,
      selected_contract: {},
      video: false,
      chosenElement: null,
      dropdownIsOpened: false
    };
  },
  emits: ["contractClickHandle", "loadingIsCompleted"],
  computed: {
    formattedText() {
      return `Договор страхования обеспечит вам уверенность и поддержку
в непредвиденной жизненной ситуации.

Благодарим за выбор страховой компании ООО «МАКС-Жизнь».`.replace(/\n/g, "<br>");
    }
  },
  methods: {
    async fetchData(params) {
      try {
        const { data } = await axios.post(url, { params: params });
        this.contracts = data.result;
        if (data.result.length > 0) {
          this.visible = true;
        }
        this.$emit("loadingIsCompleted", data.result);
      } catch (e) {
        this.errors.push(e);
      }
    },
    terminate() {
      this.$router.push({ name: "termination", params: { id: this.selected_contract.id } });
    },
    contractClickHandle(contract) {
      this.chosenElement = `Договор ${contract.name} от ${contract.date}`;
      this.$emit("contractClickHandle", contract, "tsl");
      this.dropdownIsOpened = false;
    },
    toggleDropdown() {
      this.dropdownIsOpened = !this.dropdownIsOpened;
    }
  },
  mounted() {
    let params = {
      command: "termination_contracts_list",
      token: this.$myApp.token.get()
    };
    this.fetchData(params);
  }
};
</script>

<style scoped></style>